export const typeTitleMap = {
  Project: 'Deal',
  PropertyTenant: 'Lease',
  PropertyUnit: 'Unit',
  FacilityReport: 'Historical FOIA',
  LoanQuote: 'Loan Quote',
  TimeSeries: 'Time Series',
  Trail: 'Deal Analytics',
  AssetManagement: 'Asset Management',
  Property: 'Property',
};
